(function () {
  const root = document.querySelector("[data-ekam-track]");
  if (!root) return;

  const form = root.querySelector("[data-ekam-track-form]");
  const result = root.querySelector("[data-ekam-track-result]");
  const errorBox = root.querySelector("[data-ekam-track-error]");
  const loadingBox = root.querySelector("[data-ekam-track-loading]");
  const submit = root.querySelector("[data-ekam-track-submit]");
  const proxyPath = root.getAttribute("data-proxy-path") || "/apps/ekam-track";
  const buttonLabel = root.getAttribute("data-button-label") || "Track order";

  const COPY = {
    confirmed: "We have received your order.",
    packed: "Your order is packed and waiting for pickup.",
    shipped: "Your order has been handed to Delhivery.",
    in_transit: "Your order is on the way.",
    out_for_delivery: "Your order is out for delivery today.",
    delivered: "Your order has been delivered.",
    returned: "This shipment is returning to EKAM.",
  };

  function showError(message) {
    errorBox.textContent = message;
    errorBox.classList.remove("ekam-track__hidden");
    result.classList.remove("is-visible");
    result.hidden = true;
  }

  function hideError() {
    errorBox.classList.add("ekam-track__hidden");
    errorBox.textContent = "";
  }

  function setLoading(isLoading) {
    loadingBox.classList.toggle("ekam-track__hidden", !isLoading);
    submit.disabled = isLoading;
    submit.textContent = isLoading ? "Checking…" : buttonLabel;
  }

  function formatWhen(value, compact) {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    const options = compact
      ? { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }
      : { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" };
    return date.toLocaleString("en-IN", options);
  }

  function makePill(label, value, copyValue) {
    const el = document.createElement("span");
    el.className = "ekam-track__pill";
    const strong = document.createElement("strong");
    strong.textContent = value;
    el.append(label + " ", strong);
    if (copyValue) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.textContent = "Copy";
      btn.addEventListener("click", function () {
        navigator.clipboard.writeText(copyValue).then(function () {
          btn.textContent = "Copied";
          setTimeout(function () {
            btn.textContent = "Copy";
          }, 1600);
        });
      });
      el.append(" ", btn);
    }
    return el;
  }

  function render(data) {
    const shipment = data.shipment || {};
    const returned = !!data.returned || shipment.currentKey === "returned";
    const current = returned ? "returned" : shipment.currentKey;
    const currentStep = (data.milestones || []).find(function (step) {
      return step.key === shipment.currentKey;
    });
    const status = root.querySelector("[data-status]");
    status.classList.toggle("is-returned", returned);
    root.querySelector("[data-status-kicker]").textContent = returned ? "Returned" : "Live status";
    root.querySelector("[data-status-title]").textContent = returned
      ? "Returning to EKAM"
      : (currentStep && currentStep.label) || "Order update";
    root.querySelector("[data-status-copy]").textContent = COPY[current] || "";

    const pills = root.querySelector("[data-pills]");
    pills.innerHTML = "";
    if (data.order && data.order.name) pills.appendChild(makePill("Order", data.order.name));
    if (data.order && data.order.placedAt) pills.appendChild(makePill("Placed", formatWhen(data.order.placedAt)));
    if (data.order && data.order.itemHint) pills.appendChild(makePill("Items", data.order.itemHint));
    if (shipment.awb) pills.appendChild(makePill("AWB", shipment.awb, shipment.awb));
    else pills.appendChild(makePill("Shipment", "Not handed to courier yet"));
    if (shipment.destination) pills.appendChild(makePill("Delivering to", shipment.destination));

    const stepper = root.querySelector("[data-stepper]");
    const timeline = root.querySelector("[data-timeline]");
    stepper.innerHTML = "";
    timeline.innerHTML = "";

    (data.milestones || []).forEach(function (step) {
      const h = document.createElement("li");
      h.className = "ekam-track__hstep is-" + step.state;
      h.innerHTML = '<span class="ekam-track__hdot"></span><p></p><small></small>';
      h.querySelector("p").textContent = step.label;
      h.querySelector("small").textContent = formatWhen(step.at, true);
      stepper.appendChild(h);

      const v = document.createElement("li");
      v.className = "ekam-track__step is-" + step.state;
      v.innerHTML =
        '<div class="ekam-track__rail"><span class="ekam-track__dot"></span></div>' +
        '<div><p class="ekam-track__step-title"></p><p class="ekam-track__step-meta"></p></div>';
      v.querySelector(".ekam-track__step-title").textContent = step.label;
      v.querySelector(".ekam-track__step-meta").textContent = [formatWhen(step.at), step.location]
        .filter(Boolean)
        .join(" · ");
      timeline.appendChild(v);
    });

    const scansWrap = root.querySelector("[data-scans]");
    const scansList = root.querySelector("[data-scans-list]");
    scansList.innerHTML = "";
    if (data.scans && data.scans.length) {
      data.scans
        .slice()
        .reverse()
        .forEach(function (scan) {
          const item = document.createElement("li");
          item.className = "ekam-track__scan";
          const title = document.createElement("strong");
          title.textContent = scan.label || "Update";
          const meta = document.createElement("span");
          meta.textContent = [formatWhen(scan.at), scan.location, scan.instruction].filter(Boolean).join(" · ");
          item.append(title, meta);
          scansList.appendChild(item);
        });
      scansWrap.classList.remove("ekam-track__hidden");
    } else {
      scansWrap.classList.add("ekam-track__hidden");
    }

    result.hidden = false;
    result.classList.add("is-visible");
    if (!(root.hasAttribute("data-ekam-track-demo") || (window.Shopify && Shopify.designMode))) {
      result.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    hideError();
    const orderNumber = form.orderNumber.value.trim();
    const emailOrPhone = form.emailOrPhone.value.trim();
    if (!orderNumber || !emailOrPhone) {
      showError("Enter your order number and mobile number or email.");
      return;
    }

    setLoading(true);
    fetch(proxyPath, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ orderNumber: orderNumber, emailOrPhone: emailOrPhone }),
    })
      .then(function (res) {
        const type = res.headers.get("content-type") || "";
        if (!type.includes("application/json")) {
          throw new Error("not-json");
        }
        return res.json().then(function (body) {
          return { ok: res.ok, body: body };
        });
      })
      .then(function (payload) {
        if (!payload.body || !payload.body.ok) {
          showError(
            (payload.body && payload.body.error) ||
              "We couldn't find a matching order. Check your order number and mobile or email.",
          );
          return;
        }
        render(payload.body);
      })
      .catch(function () {
        showError("Tracking is not available right now. Please try again shortly, or email cs@ekamonline.com.");
      })
      .finally(function () {
        setLoading(false);
      });
  });

  const preview = root.querySelector("[data-ekam-track-preview]");
  if (preview && (root.hasAttribute("data-ekam-track-demo") || (window.Shopify && Shopify.designMode))) {
    try {
      render(JSON.parse(preview.textContent));
    } catch (e) {
      /* editor preview is optional */
    }
  }
})();
